import { Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import ChatUserInfo from "../chatUserInfo";
import styles from "./chatVideoMessage.module.scss";
//import file_loader from "../../../../styles/images/file_loader.svg";
import ChatHoverOption from "../chatHoverOption";
import moment from "moment";
import ChatLeftInfo from "../chatLeftInfo";
import ChatRightInfo from "../chatRightInfo";
import ChatLike from "../chatLike";
import { useSelector } from "react-redux";
import { Types } from "../../../../context/action/action";
import store from "../../../../context/store/store";
import { chats, initialStateModel } from "../../../../models/model";
import { URCheckBoxCall } from "../../../../shared/widgets/checkBoxForCall/callCheckBox";
import _ from "lodash";
import ChatVideoPlayer from "../chatVideoPlayer";
import ForwardHeader from "../forwardHeader";
import { urlify, urlifyATmention } from "../../../../base/utils";
import { ChatService } from "../../../../base/chatService";
type videoMessageProps = {
  data: any;
  previewopen: Function;
  savedData?: any;
  timeValue?:any
}
type videoMessageState = {
  pausePlay: any;
  duration: any;
  durationArr: any;
}
export default function ChatVideoMessage({ data, previewopen, savedData,timeValue }: videoMessageProps) {
  let { id, direction, timestamp, fromcaller_details } = Array.isArray(data) && data?.length > 0 ? data[0] : "";
  let messageBody = Array.isArray(data) && data?.length > 0 ? data[0].message.body : "";
  let isReply = Array.isArray(data) && data?.length > 0 && data[0].message?.isReply ? true : false;
  let timeCount = timeValue !== undefined ? timeValue : 18;
  const [longText, setlongtext] = useState(0);
  const { userdetails }: any = useSelector((state: initialStateModel) => state.loginReducer);
  let mstext = messageBody?.text;
  if(mstext && mstext !== ""){
    if (mstext.length > 760 && longText === 0) {
      mstext = mstext.substring(0, 760) + "...";
    }
  }
  if(messageBody?.mentionID !== '' && messageBody?.mentionID !== undefined ){
    let test = urlifyATmention(messageBody ,mstext)
    mstext = test;
   }
  const readMoreChange = ()=>{
    setlongtext(1);
  }
  // let filePath = messageBody?.filePath;
  const [videoState, setvideoState] = useState<videoMessageState>({ pausePlay: false, duration: '00:00', durationArr: [] });

  let htimestamp = moment(timestamp).format('hh:mm A');

  useEffect(() => {
    var focusableInputElements: any = document.querySelectorAll(".focusText");
    if (focusableInputElements.length > 0 && (chatReducer.isSaveChat)) {

      focusableInputElements[0].focus();
    }
  }, [savedData]);

  useEffect(() => {
    let arr: any = []
    _.forEach(data, function (element: any) {

      let modifyID = element?.id
      let idele = modifyID.split('-').join('');
      let myVideo: any = document.getElementById(idele);
      const durationRes = duration(myVideo?.duration);
      
      //element['duration'] = durationRes;
     // element['pausePlay'] = false;
      // element['id'] = idele;
      arr.push(element);
    });

    setvideoState({ ...videoState, durationArr: arr });

  }, []);

  const handlehighlightHover = () => {
    var element: HTMLElement | any = document.getElementById(id) || null;
    if (element != null) {
      element.classList.add("highlighthover");
    }
  };

  const duration = (time: any) => {
    let timeDuration: any;
    let d = Number(time);
    let h = Math.floor(d / 3600);
    let m = Math.floor(d % 3600 / 60);
    let s = Math.floor(d % 3600 % 60);

    let hDisplay = h > 0 ? `0${h}` : h > 10 ? h : "00";
    let mDisplay = m < 9 ? `0${m}` : m > 10 ? m : "00";
    let sDisplay = s < 9 ? `0${s}` : s > 10 ? s : "00";
    timeDuration = hDisplay > 0 ? `${hDisplay}:${mDisplay}:${sDisplay}` : `${mDisplay}:${sDisplay}`;
    return timeDuration;
  }

  // const videoPlay = (id:any) =>{
  //   let myVideo:any = document.getElementById(id);
  //   const durationRes =  duration(myVideo?.duration);
  //   _.forEach(videoState?.durationArr, function(element: any) {
  //     if(element?.id === id) {
  //       element.duration = durationRes;
  //       element.pausePlay =  !element.pausePlay
  //     }

  //   });
  //   let fileArr = _.find(videoState?.durationArr, function(o:any) { return o?.id === id });
  //   setvideoState({...videoState,pausePlay:!videoState.pausePlay});

  //   if(fileArr?.pausePlay === true && myVideo?.duration > 1){
  //     myVideo?.play();
  //   }
  //   else if(fileArr?.pausePlay===false && myVideo?.duration > 1){
  //     myVideo?.pause();
  //   }
  // };

  const chatReducer: chats = useSelector((state: initialStateModel) => state.chatReducer);

  const handleCheckBoxClick = (data:any,direction:any) => {
    if (chatReducer?.multiOption && (direction=== "IN" || direction=== "OUT")) {
      ChatService.selectedMessageDispatch(data);
    }
     else if (chatReducer?.isDelete && direction=== "OUT"){
      ChatService.selectedMessageDispatch(data);
     }
  };

  const handleOnChange = (e: any) => {
    let deletedArray: any = chatReducer.selectMessageData;
    let index = [];
    if (e.target.checked) {
      let arr: any = [...deletedArray, ...data]
      store.dispatch({
        type: Types.SELECT_MESSAGE_ARRAY,
        payload: {
          selectMessageData: arr
        }
      });
    } else {
      _.forEach(data, function (element: any) {
        index = deletedArray.indexOf(element);
        deletedArray.splice(index, 1);
      });

      store.dispatch({
        type: Types.SELECT_MESSAGE_ARRAY,
        payload: {
          selectMessageData: deletedArray
        }
      });
      setvideoState({ ...videoState, durationArr: data });
    }
  };
  let isBookmark:any = data[0]?.message?.isSave;
  let widthMulti = (!data[0].message.isDelete && (!isBookmark || isBookmark["s" + userdetails?.sip_login_id]) === 1 ) && data[0]?.message?.isEdit ?"saveEdited": 
  (!data[0]?.message?.isDelete && (!isBookmark || isBookmark["s" + userdetails?.sip_login_id]) === 1 )?"onlySaved": data[0]?.message?.isEdit ? "onlyEdited" : "widthDefault";
 
  try {
    return (
      <>
        {
          direction === "IN" ? <div className={`${chatReducer.isSaveChat &&
            id === savedData ? 'savedhighlight' : ""
            } lftMessage ${styles.chatMsg} ${styles.leftMessage} ${(chatReducer?.multiOption && chatReducer?.selectMessageData?.indexOf(data[0]) > -1 ) ? "checked" : chatReducer?.multiOption?"checking":""}`} id={id} 
            onClick={() => handleCheckBoxClick(data[0], "IN")}>
         {timeCount > 15 &&  <div className={`${styles.chatUserDetails}`} >
              {!isReply && <ChatUserInfo userDetails={fromcaller_details ? fromcaller_details : 'Unknown User'} className='userinfoIcon leftSide' />}
              <div className={styles.convMemName}><span>{fromcaller_details ? fromcaller_details?.caller_id : 'Unknown User'}</span></div>
            </div>}
            <div className={styles.chatLeftMessages}>
              <div className={styles.chatLeft}>
                {!isReply && <Tooltip title={htimestamp} className='cusTooltip'
                  overlayClassName='customTooltip'><div className={styles.chatTime}>{htimestamp}</div></Tooltip>}
                
                <div className={`msgContentLft ${styles.chatContent}`}>
                {Array.isArray(data) && data[0]?.message?.forward && <ForwardHeader />} 
                  {videoState.durationArr?.reverse().map((msgList: any, index: any) => {
                    // let messageBody = JSON.parse(msgList.message.body);
                    return (
                      <React.Fragment key={index}>
                        <span key={index} className={id === savedData ? "focusText" : ""} tabIndex={0}>
                          <ChatVideoPlayer data={msgList} multiData={data}></ChatVideoPlayer>
                        </span>
                      </React.Fragment>)
                  })}
                    
                    {messageBody?.text && messageBody?.text !== "" &&
                      <div className="textContent">
                      <span className={`textmsg ${styles.messageContent}`} >
                     <span  dangerouslySetInnerHTML={{ __html: urlify(mstext) }}></span>
                      {mstext.length > 760 && longText === 0 && <span className="chatReadMore" onClick={() => readMoreChange()}>Read more</span>}
                    </span>
                      <span className={widthMulti}></span>
                    </div>
                    } 
                  {!isReply && <div className={`chatInnerHoveroptn ${styles.hoverOptions}`}>
                    <ChatHoverOption className='hoverList hoverListleft' data={Array.isArray(data) && data?.length > 0 && data[0]} multiFile={videoState?.durationArr} highlightHover={handlehighlightHover} /></div>}
                    {!isReply && <ChatLeftInfo userDetails={fromcaller_details} timeStamp={timestamp}
                message={Array.isArray(data) && data.length > 0 ? data[0] : []}></ChatLeftInfo>}
                </div>
              </div>
            </div>
            {!isReply && <ChatLike className='likeLeft' placement="top"
              tooltipTitle={data?.likeduserdetails}
              message={Array.isArray(data) && data.length > 0 ? data[0] : []} />}
              {(chatReducer?.multiOption && !chatReducer?.isDelete) && (
            <URCheckBoxCall
            checked={chatReducer?.selectMessageData?.indexOf(data[0]) > -1 ? true : false}
            className="chatSelectRight"  />
          )}
          </div>
            :
            <div className={`${chatReducer.isSaveChat &&
              id === savedData ? 'savedhighlight' : ""
              } rtMessage ${styles.chatMsg} ${styles.rightMessage} 
              ${(chatReducer?.multiOption && chatReducer?.selectMessageData?.indexOf(data[0]) > -1 ) ? "checked" : chatReducer?.multiOption? "checking":""}`
            } onClick={() => handleCheckBoxClick(data[0], "OUT")} id={id}>
             {timeCount > 15 &&    <div className={`${styles.chatUserDetails}`}>
                <div className={styles.convMemName}><span>You</span></div>
                {!isReply && <ChatUserInfo userDetails={fromcaller_details} className='userinfoIcon rightSide' />}
                {/* <URCheckBox className="chatSelectRight"/> */}
              </div>}
              <div className={styles.chatRightMessages} >
                <div className={styles.chatRight} >
                  <div className={`msgContentRT ${styles.chatContent}`}>
                  {Array.isArray(data) && data[0]?.message?.forward && <ForwardHeader />} 
                    {videoState.durationArr?.reverse().map((msgList: any, index: any) => {
                      return (
                        <React.Fragment key={index}>
                          <span key={index} className={id === savedData ? "focusText" : ""} tabIndex={0}>
                            <ChatVideoPlayer data={msgList} multiData={data}></ChatVideoPlayer>
                          </span>
                        </React.Fragment>)
                    })}
                  
                    {messageBody?.text && messageBody?.text !== "" &&
                      <div className="textContent">
                      <span className={`textmsg ${styles.messageContent}`} >
                     <span  dangerouslySetInnerHTML={{ __html: urlify(mstext) }}></span>
                      {mstext.length > 760 && longText === 0 && <span className="chatReadMore" onClick={() => readMoreChange()}>Read more</span>}
                    </span>
                      <span className={widthMulti}></span>
                    </div>
                    } 
                    {!isReply && <ChatRightInfo userDetails={fromcaller_details}
                  timeStamp={timestamp} message={Array.isArray(data) && data.length > 0 ? data[0] : []} ></ChatRightInfo>}
                    {!isReply && <div className={`chatInnerHoveroptn ${styles.hoverOptions}`}>
                      <ChatHoverOption className='hoverList hoverListright' data={Array.isArray(data) && data?.length > 0 && data[0]} multiFile={videoState?.durationArr} highlightHover={handlehighlightHover} /></div>}
                  </div>
                  {!isReply && <Tooltip placement="topRight" title={htimestamp} className='cusTooltip'
                    overlayClassName='customTooltip'><div className={styles.chatTime}>{htimestamp}</div></Tooltip>}
                </div>

              </div>
              {(!chatReducer?.isDelete && chatReducer?.multiOption) && <URCheckBoxCall
                checked={chatReducer?.selectMessageData?.indexOf(data[0]) > -1 ? true : false}
                className="chatSelectRight"  />}
              {!isReply && <ChatLike className='likeRight' placement="topRight"
                tooltipTitle={data?.likeduserdetails} message={Array.isArray(data) && data.length > 0 ? data[0] : []} />}
            </div>

        }




      </>
    );
  } catch (e) {
    return <p style={{ color: 'red' }}>Something went wrong</p>;
  }
};

